import Hls from 'hls.js';

export default class AutoplayVideos {
	constructor() {
		if (!'IntersectionObserver' in window) {
			return;
		}

		this.reduceMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

		this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
			rootMargin: '200px',
		});

		document.addEventListener('bless', (e) => {
			const container = e.target;
			this.init(container);
		});
	}

	init(container) {
		const autoplayVideos = container.querySelectorAll('[data-autoplay-video]');
		autoplayVideos.forEach((autoplayVideo) => {
			if (this.reduceMotionMediaQuery.matches) {
				autoplayVideo.dispatchEvent(new CustomEvent('show-poster'));
				return;
			}
			new AutoplayVideoVideo(autoplayVideo);
			this.intersectionObserver.observe(autoplayVideo);
		});
	}

	handleIntersection(entries) {
		entries.forEach((entry) => {
			const ratio = entry.intersectionRatio;
			const target = entry.target;

			// Video is in viewport
			if (ratio > 0) {
				target.dispatchEvent(new CustomEvent('play-video'));
			}else{
				// Video is outside viewport and ready to be paused
				target.dispatchEvent(new CustomEvent('pause-video'));
			}
		});
	}

}
class AutoplayVideoVideo {
	constructor(wrapper) {

		this.wrapper = wrapper;
		this.video = this.wrapper.querySelector('video');

		if (!this.video) {
			return;
		}

		this.startHls();

		this.wrapper.addEventListener('play-video', () => {
			this.playVideo();
		});

		this.wrapper.addEventListener('pause-video', () => {
			this.pauseVideo();
		});

		this.wrapper.addEventListener('show-poster', () => {
			this.showPoster();
		});

	}

	startHls() {

		const video = this.video;

		const videoSrc = video.dataset['hlsSrc'];
		//
		// First check for native browser HLS support
		//
		if (video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = videoSrc;
			//
			// If no native HLS support, check if HLS.js is supported
			//
		} else if (Hls.isSupported()) {
			const hls = new Hls({
				"capLevelToPlayerSize": true,
			});
			hls.loadSource(videoSrc);
			hls.attachMedia(video);
		}

	}

	playVideo() {
		let startPlayPromise = this.video.play();
		if (startPlayPromise !== undefined) {
			startPlayPromise
				.then(() => {
					this.hidePoster()
					this.wrapper.classList.add('is-playing');
				})
				.catch((error) => {
					if (!this.wrapper) {
						return;
					}
					setTimeout(() => {
						if (!this.wrapper.classList.contains('is-playing')) {
							this.showPoster();
						}
					}, 2000);
				});
		}
	}

	showPoster(){
		this.wrapper.classList.add('show-poster');
	}

	hidePoster(){
		this.wrapper.classList.remove('show-poster');
	}

	pauseVideo() {
		this.video.pause();
	}

}
